export default __webpack_public_path__ + "static/media/farmqrbg.c79821b5.png";